<div mat-dialog-title>
    <h2 *ngIf="!isReportedOrder">{{"wastedFood.Report Wasted Menu Item" | translate}}</h2>
    <h2 *ngIf="isReportedOrder">{{'wastedFood.Report a Problem with an Order' | translate }}</h2>
    <button mat-icon-button class="close" (click)="openConfirmDialog()">
        <mat-icon class="pop-close">close</mat-icon>
    </button>
</div>

<div class="report-dialog">
    <!-- if it's Opens from Reports Tab not from Orders -->
    <div class="row m-2" *ngIf="!isReportedOrder">
        <div class="col-sm-12 mb-2">
            <div class="grey-list-items">
                <div class="list-item border border-raduis">
                    <div class="align-items-center">
                        <span class="info no-icon font-16 fontMedium">{{"wastedFood.Is this Item within an order?" | translate}}</span>
                    </div>
                    <div>
                        <mat-slide-toggle (toggleChange)="getOrdersList()" [(ngModel)]="isOrder" [ngModelOptions]="{standalone: true}"></mat-slide-toggle>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- From Reports Tab -->
    <div class="modal-subhead" *ngIf="!isReportedOrder && !isOrder">
        <div class="row">
            <div class="col-7 d-block m-auto">
                <div class="form-group">
                    <div class="input-group search-control">
                        <div class="input-group-prepend">
                            <button class="input-group-text" type="button">
                                <img src="./assets/images/icons/search.svg" alt="">
                            </button>
                        </div>
                        <input type="text" maxlength="20" class="form-control font-14"
                            [placeholder]="'forms.Search for items' | translate" (keyup.enter)="getMenuItems(true)"
                            [(ngModel)]="searchText" [ngModelOptions]="{standalone: true}" [pattern]="noSpecialTxt"
                            #search="ngModel">
                    </div>
                </div>
                <div class="has-error" *ngIf="(search.errors?.['pattern'] && search.touched)">{{ 'forms.Invalid value' |
                    translate }}</div>
            </div>
            <div class="col-1">
                <mat-icon matBadge="." matBadgeColor="warn" *ngIf="sectionSelected.length"></mat-icon>
                <img class="image-badge" src="./assets/images/icons/filter-outline.svg">
            </div>
            <div class="col-4 pl-0 w-auto">
                <mat-form-field appearance="fill" [class.loading-field]="sectionLoading">
                    <mat-label class="font-14">{{'wastedFood.Filter by Section' | translate}}</mat-label>
                    <mat-select multiple [(ngModel)]="sectionSelected" [ngModelOptions]="{standalone: true}"
                        (selectionChange)="getMenuItems(true)">
                        <!-- <mat-option>{{'forms.None' | translate}}</mat-option> -->
                        <mat-option [value]="section.id" *ngFor="let section of sections" class="font-16">
                            {{section.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
    </div>

    <form [formGroup]="formGroup">

        <mat-dialog-content class="mt-0 pt-2 report-dialog">
            <div class="mat-dialog-body ">

                <div class="fields-group">

                    <!-- Order Number Selection -->
                    <!-- From Reports Tab -->
                    <div class="row ml-2 mr-2 orderList" *ngIf="isOrder && !isReportedOrder">
                        <div class="col-sm-12 hide-select-clear">

                            <mat-form-field class="ng-select-field">
                                <ng-select ngSelectMat [placeholder]='("orders.Order Number" | translate)'
                                  appearance="outline" bindValue="id" bindLabel="orderNumber" [loading]="orderLoading"
                                  (change)="onOrderChange(formGroup.controls['orderId'].value)" formControlName="orderId">
                                  <ng-container *ngFor="let order of ordersList">
                                    <ng-option  [value]="order.id">
                                        <span>#{{order.orderNumber}}</span>
                                    </ng-option>
                                  </ng-container>
                                </ng-select>
                              </mat-form-field>
                        </div>
                    </div>

                    <!-- Report a Problem with an Order -->
                    <div class="modal-subhead" *ngIf="isReportedOrder">{{'wastedFood.Orders Items' | translate }} <span
                            *ngIf="orderItems.length">{{orderItems.length}}</span></div>

                    <!-- From Reports Tab -->
                    <ng-container *ngIf="!isOrder && !isReportedOrder">
                        <!-- Menu Items Filtered -->
                        <div class="menu-items ml-4 mr-4 mt-3 mb-0"
                              infiniteScroll
                              [scrollWindow]="false"
                              [infiniteScrollDistance]="1"
                              [infiniteScrollThrottle]="pageCount"
                              (scrolled)="getNextPage()"
                              [fromRoot]="true">
                            <mat-radio-group formControlName="menuItemId" (ngModelChange)="getSelecteditemSizes()">
                                    <div *ngFor="let item of itemsList" [hidden]="(searchText && hideOption(item))" class="items-radios">
                                        <mat-radio-button  class="d-block ml-0 py-3"
                                        [value]="item.id" [disabled]="!item.isAvailable">
                                            <div class="name-with-image ml-3">
                                                <div class="image-circle">
                                                    <img class="p-0" [src]="item.itemIcon" alt="">
                                                </div>
                                                <div class="name">
                                                    <h5 class="font-16">{{item.itemName}}</h5>
                                                </div>
                                            </div>
                                        </mat-radio-button>
                                    </div>
                            </mat-radio-group>
                        </div>
                        <div *ngIf="isSubmitted && hasError(formGroup, 'menuItemId', 'required')"
                          class="has-error mb-4 ml-4">
                          {{ 'forms.Required' | translate }}
                        </div>
                        <div *ngIf='itemsLoading' class="dataLoading">
                            <mat-spinner class="m-auto" diameter="25"></mat-spinner>
                        </div>
                        <div class="data-empty" *ngIf="!itemsLoading && isAllHidden()">
                            <p>{{"general.No Data Found" | translate}}</p>
                        </div>
                    </ng-container>

                    <!-- Report a Problem with an Order || Orders Tab -->
                    <ng-container *ngIf="isOrder || isReportedOrder">
                        <div class="order-items-list p-0 mx-4 pl-1">
                            <div class="order-item py-2" *ngIf="!orderItemsLoading">
                                <mat-radio-group formControlName="menuItemId">
                                    <mat-radio-button *ngFor="let item of orderItems" [value]="item.id"
                                        class="d-block ml-0 mt-2 mb-2 pt-3 pb-3">
                                        <div class="item-info-container">
                                            <div class="right d-flex">
                                                <div class="font-14 fontMedium">X{{item.quantity}}</div>
                                            </div>
                                            <div class="item-details">
                                                <div class="font-14 fontSemiBold">{{item.itemName}}</div>
                                                <div class="mt-1 font-12" *ngIf="item.sizeName">
                                                    <span class="grey-color">{{'orders.size' | translate}}:</span> <span
                                                        class="ml-1">{{item.sizeName}}</span>
                                                </div>
                                                <div class="item-options">
                                                    <div *ngIf="item.unWantedOptionalIngredients?.length">
                                                        <div class="grey-color font-12">{{'orders.Unwanted Ingredients' |
                                                            translate}}:</div>
                                                        <div class="unwanted"
                                                            *ngFor="let ingr of item.unWantedOptionalIngredients">
                                                            {{ingr.name}}</div>
                                                    </div>
                                                    <div *ngFor="let addition of item.additions">
                                                        <div class="grey-color font-12">{{addition.name}}:</div>
                                                        <ng-container *ngFor="let one of addition.itemAdditionlist">
                                                            <div class="font-12" *ngIf="one.isSelected">{{one.name}}</div>
                                                        </ng-container>
                                                    </div>
                                                    <div *ngFor="let variant of item.variants">
                                                        <div class="grey-color font-12">{{variant.name}}:</div>
                                                        <ng-container *ngFor="let one of variant.itemVariantlist">
                                                            <div class="font-12" *ngIf="one.isSelected">{{one.name}}</div>
                                                        </ng-container>
                                                    </div>
                                                    <div *ngIf="item.specialRequest">
                                                        <div class="orange-color font-12">{{'orders.Note' | translate}}:
                                                        </div>
                                                        <div class="font-12">{{item.specialRequest}}</div>
                                                    </div>

                                                </div>
                                                <div class="mt-3"
                                                *ngIf="item.quantity > 1 && (formGroup.controls['menuItemId'].value == item.id ) && !item.isWeight">
                                                    <div class="select-Qty d-flex">
                                                        <select class="form-control" style="width: 50%;"
                                                            [(ngModel)]="item.selectedQuantity"
                                                            [ngModelOptions]="{standalone: true}">
                                                            <ng-container
                                                                *ngFor="let in of counter(item.quantity); let i = index">
                                                                <option *ngIf="i != 0">{{i}}</option>
                                                            </ng-container>
                                                        </select>
                                                        <span
                                                            class="font-12 fontRegular grey-color ml-3 d-flex align-items-center">{{'orders.of selected' | translate: {no: item.quantity} }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </mat-radio-button>
                                </mat-radio-group>
                            </div>
                            <div *ngIf='orderItemsLoading' class="dataLoading">
                                <mat-spinner class="m-auto" diameter="25"></mat-spinner>
                            </div>
                            <div *ngIf="isSubmitted && hasError(formGroup, 'menuItemId', 'required')"
                                class="has-error mb-4">
                                {{ 'forms.Required' | translate }}
                            </div>
                        </div>
                        <div class="data-empty" *ngIf="!orderItemsLoading && !orderItems.length && formGroup.controls['orderId'].value">
                            <p>{{"general.No Data Found" | translate}}</p>
                        </div>
                        <div class="data-empty" *ngIf="!orderItemsLoading && !formGroup.controls['orderId'].value">
                            <p>{{'wastedFood.Please select an Order first' | translate }}</p>
                        </div>
                    </ng-container>

                    <div class="row m-2" *ngIf="formGroup.controls['menuItemId'].value && SelecteditemSizes?.length">
                        <div class="col-sm-12 mb-2 mt-3">
                            <p class="font-16 fontMedium">{{'wastedFood.Wasted Menu Item Size' | translate }}</p>
                        </div>
                        <div class="col-sm-12">
                            <mat-radio-group class="radio-square-list small"
                                formControlName="itemSizesId" [required]="!isOrder || !isReportedOrder">
                                <ng-container *ngFor="let size of SelecteditemSizes;">
                                    <mat-radio-button [value]="size.itemSizesId" [disabled]="!size.isAvailable"
                                    [matTooltip]="!size.isAvailable ? NotAvailable : IsAvailable">
                                        {{size.sizeName}}
                                    </mat-radio-button>
                                </ng-container>
                            </mat-radio-group>
                            <div *ngIf="isSubmitted && formGroup.controls['menuItemId'].value && hasError(formGroup, 'itemSizesId', 'required')" class="has-error mb-4">
                                {{ 'forms.Required' | translate }}
                            </div>
                        </div>
                    </div>

                    <div class="row m-2">
                        <div class="col-sm-12 mb-2 mt-3">
                            <p class="font-16 fontMedium">{{'wastedFood.Loss Reason' | translate }}</p>
                        </div>
                        <div class="col-sm-12">
                            <mat-radio-group class="radio-square-list small" *ngIf="!lossReasonLoading"
                                formControlName="lossReasonId">
                                <ng-container *ngFor="let reason of lossReason;">
                                    <mat-radio-button [value]="reason.id">
                                        {{reason.name}}
                                    </mat-radio-button>
                                </ng-container>
                            </mat-radio-group>
                            <div *ngIf='lossReasonLoading' class="dataLoading">
                                <mat-spinner class="m-auto" diameter="25"></mat-spinner>
                            </div>
                            <div *ngIf="isSubmitted && hasError(formGroup, 'lossReasonId', 'required')"
                                class="has-error mb-4">
                                {{ 'forms.Required' | translate }}
                            </div>
                        </div>
                    </div>

                    <div class="row m-2">
                        <div class="col-sm-12 mb-2 mt-3">
                            <p class="font-16 fontMedium">{{'wastedFood.Disposition' | translate }}</p>
                        </div>
                        <div class="col-sm-12">
                            <mat-radio-group class="radio-square-list small" *ngIf="!dispositionLoading"
                                formControlName="dispositionLookupId">
                                <ng-container *ngFor="let reason of disposition;">
                                    <mat-radio-button [value]="reason.id">
                                        {{reason.name}}
                                    </mat-radio-button>
                                </ng-container>
                            </mat-radio-group>
                            <div *ngIf='dispositionLoading' class="dataLoading">
                                <mat-spinner class="m-auto" diameter="25"></mat-spinner>
                            </div>
                            <div *ngIf="isSubmitted && hasError(formGroup, 'dispositionLookupId', 'required')"
                                class="has-error mb-4">
                                {{ 'forms.Required' | translate }}
                            </div>
                        </div>
                    </div>

                    <div class="row m-2 mt-3">
                        <div class="col-sm-12 mb-2 mt-3">
                            <p class="font-16 fontMedium">{{'forms.Notes' | translate }}</p>
                        </div>
                        <div class="col-sm-12">
                            <mat-form-field hideRequiredMarker>
                                <mat-label>{{ 'wastedFood.Type your note here' | translate }}</mat-label>
                                <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                    cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5" maxlength="100"
                                    formControlName="note"></textarea>
                                <mat-hint class="ml-0">{{'forms.Optional' | translate}}</mat-hint>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row m-2" *ngIf="isOrder || isReportedOrder">
                        <div class="col-sm-12 mb-2">
                            <div class="grey-list-items form-group mt-3">
                                <div class="list-item">
                                    <div class="d-flex align-items-center">
                                        <p class="mx-3 info font-12 no-icon text-center fontMedium">{{"wastedFood.Please keep in mind that once you submit the report, the time of order will be sent automatically to the kitchen to prepare again" | translate }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </mat-dialog-content>

        <mat-dialog-actions>
            <button mat-button class="btn-grey" (click)="openConfirmDialog()">
                {{"forms.Cancel" | translate}}
            </button>

            <button mat-raised-button color="primary" [disabled]="loading" (click)="saveRecord()" [class.loading]="loading">
                {{"wastedFood.Submit report" | translate}}
            </button>
        </mat-dialog-actions>
    </form>
</div>
